import { type AdditionalDetailsSpecsFragment } from '../../../../api/fragments/AdditionalDetailsSpecs';
import { type PackageSettingsSpecsFragment } from '../../../../api/fragments/PackageSettingsSpecs';
import { BlockType, PackageKind, type PackageSettingsInput, type TranslatedStringInput } from '../../../../api/types';

export const FORM_NAME = 'variantConfiguratorPackageBlocks';

export type PackageAdditionalDetailValues = Pick<AdditionalDetailsSpecsFragment, 'title' | 'description'> & {
    id?: string;
    image?: File | AdditionalDetailsSpecsFragment['image'];
};

export type PackageSettingValues = Omit<
    PackageSettingsSpecsFragment,
    'id' | 'sectionImage' | 'packageType' | '__typename' | 'additionalDetails' | 'packageName'
> & {
    id?: string; // package setting id
    sectionImage?: File | PackageSettingsSpecsFragment['sectionImage'];
    packageType: PackageSettingsInput['packageType'];
    additionalDetails?: PackageAdditionalDetailValues[];
    packageName: TranslatedStringInput;
};

export type PackageBlockInput = {
    id?: string; // block id
    isActive: boolean;
    packageSettings?: PackageSettingValues[];
};

export type PackageBlockFormValues = {
    type: BlockType.Package;
    packageBlockInput: PackageBlockInput;
};

export const getDefaultPackageBlock = (): PackageBlockFormValues => ({
    type: BlockType.Package,
    packageBlockInput: {
        isActive: true,
        packageSettings: [
            {
                packageName: {
                    defaultValue: '',
                    overrides: [],
                },
                features: [],
                additionalDetails: [],
                packageType: {
                    type: PackageKind.Price,
                    packageTypeWithPriceInput: {
                        price: 0,
                        financing: false,
                    },
                },
            },
        ],
    },
});

export const getDefaultPackageSetting = (): PackageSettingValues => ({
    packageName: {
        defaultValue: '',
        overrides: [],
    },
    features: [],
    additionalDetails: [],
    packageType: {
        type: PackageKind.Price,
        packageTypeWithPriceInput: {
            price: 0,
            financing: false,
        },
    },
});

export const defaultPackageBlockValues = getDefaultPackageBlock();
